<template>
<div class="main">
  <el-main class="page-content-margin-unset">
    <!-- 编辑 -->
    <h3>用户信息</h3>
    <div class="detail">
      <el-form
        :inline="false"
        status-icon
        label-position="left"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item
          v-if="body.user_info"
          class="dk-input"
          label="头像:">
          <img
            :src="body.user_info.avatar"
            width="141px">
        </el-form-item>
        <el-form-item
          v-if="body.user_info"
          class="dk-input"
          label="用户名称:">
          <span>{{ body.user_info.nickname }}</span>
        </el-form-item>
        <el-form-item
          v-if="body.user_info"
          class="dk-input"
          label="手机号:">
          <span>{{ body.user_info.mobile}}</span>
        </el-form-item>
        <h3>案例信息</h3>
        <el-form-item
          class="dk-input"
          label="案例名称:">
          <span>{{ body.name }}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="排序:">
          <span>{{ body.priority }}</span>
        </el-form-item>
        <el-form-item
          label="关联品牌:">
          <span v-for="(brand,index) in body.brand" :key="index">
            {{ brand.name }}
          </span>
        </el-form-item>
        <el-form-item
          v-if="body.style_name"
          label="风格:">
          <span>{{ body.style_name.name }}</span>
        </el-form-item>
        <el-form-item
          label="城市:">
          <span>{{ body.city }}</span>
        </el-form-item>
        <el-form-item
          label="封面图:">
          <img
            :src="imgDomain+'/'+ body.index_img"
            width="141px" @click="imgPre(imgDomain+'/'+ body.index_img)">
        </el-form-item>
        <h3>案例详情</h3>
        <el-form-item
          label="状态:">
          <span>{{ body.is_audit }}</span>
        </el-form-item>
        <el-form-item
          label="图片(1-9张):">
          <img
            v-for="(img,index) in body.img_list"
            style="margin: 0 0 10px 10px"
            :src="imgDomain + img"
            width="141px" @click="imgPre(imgDomain + img)" :key="index">
        </el-form-item>
        <el-form-item
          label="案例说明:">
          <span>{{ body.content }}</span>
        </el-form-item>
        <el-form-item
          v-if="body.is_audit !== '待审核'"
          label="审核时间:">
          <span>{{ body.update_time }}</span>
        </el-form-item>
        <el-form-item
          v-if="body.is_audit === '已拒绝'"
          label="拒绝理由:">
          <span>{{ body.audit_reason }}</span>
        </el-form-item>
        <el-button
          size="mini"
          type="primary"
          class="mini-el-button"
          @click="event().onBackClick()"
        >返回</el-button>
        <el-button
          v-if="body.is_audit === '待审核'"
          size="mini"
          type="primary"
          class="mini-el-button"
          @click="event().toConfirmClick()">
          通过
        </el-button>
        <el-button
          v-if="body.is_audit === '待审核'"
          size="mini"
          type="primary"
          class="mini-el-button"
          @click="event().toRefuseClick()">
          拒绝
        </el-button>
      </el-form>
    </div>

    <!-- 通过兑换 -->
    <el-dialog
      width="480px"
      title="提示，是否确认通过 ?"
      :visible.sync="toConfirmBodyDialog">
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="toConfirmBodyDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToConfirmClick()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 拒绝兑换 -->
    <el-dialog
      width="350px"
      title="提示，确认是否拒绝 ?"
      :visible.sync="toRefuseBodyDialog">
      <el-form
        :model="toRefuseBody"
        ref="ruleForm3"
        class="demo-ruleForm">
        <el-input
          placeholder="请输入拒绝理由"
          type="textarea"
          class="dk-input"
          v-model="toRefuseBody.audit_reason"/>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="toRefuseBodyDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToRefuseClick('ruleForm3')">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
  <modal :url='imgPreUrl' :modal='modal' style="width:100%" @chose='chose'></modal>
</div>

</template>

<script>
import { imgDomain } from '../../configs/env'
import { getExampleDetail, setExampleStatus } from '../../api/case'
import modal from '../../components/modal'
export default {
  components:{
    modal
  },
  data() {
    return {
      imgDomain,
      body: {
      },
      pointBody: {},
      toConfirmBodyDialog: false,
      toRefuseBodyDialog: false,
      toConfirmBody: {},
      toRefuseBody: {},
      imgPreUrl:'',
      modal:false,
    };
  },
  created() {
    this.network().getExampleDetail()
  },
  methods: {
    imgPre(url){
      this.modal=true
      this.imgPreUrl=url
    },
    chose(e){
      this.modal=e
    },
    event() {
      return {
        onBackClick: () => {
          this.$router.go(-1)
        },
        toConfirmClick: (uuid) => {
          this.toConfirmBody.uuid = this.$route.query.uuid
          this.toConfirmBodyDialog = true
        },
        toRefuseClick: (uuid) => {
          this.toRefuseBody.uuid = this.$route.query.uuid
          this.toRefuseBodyDialog = true
        },
        onSureToConfirmClick: () => {
          this.toConfirmBody.is_audit = 1;
          this.network().setExampleStatus(this.toConfirmBody)
        },
        onSureToRefuseClick: () => {
          this.toRefuseBody.is_audit = 2;
          this.network().setExampleStatus(this.toRefuseBody)
        },
      }
    },
    network() {
      return {
        getExampleDetail: async () => {
          const { status, data } = await getExampleDetail({'uuid': this.$route.query.uuid})
          if (status !== 200) return
          this.body = data
        },
        setExampleStatus: async (data) => {
          const { status } = await setExampleStatus(data)
          if (status !== 200) return
          this.network().getExampleDetail()
          if (data.is_audit === 1) {
            this.toConfirmBodyDialog = false
            this.$notify({
              title: '通过成功',
              message: '通过成功',
              type: 'success',
            });
          } else if (data.is_audit === 2) {
            this.toRefuseBodyDialog = false
            this.$notify({
              title: '拒绝成功',
              message: '拒绝成功',
              type: 'success',
            });
          }
        },
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main{
  .detail{
  display: flex;
}
.img{
  min-width: 148px;
  height: 148px;
  border-radius: 6px;
  border: 1px solid #c0ccda;
  margin: 0 20px 20px 0;
}
}

</style>



// WEBPACK FOOTER //
// src/vuepage/case/detail.vue